import { createAction } from '@reduxjs/toolkit';

import { InitAuthSaga } from 'store/types/auth';

const AUTH_TYPE = 'auth';

export const authActions = {
  initAuth: createAction<InitAuthSaga>(`${AUTH_TYPE}/initAuth`),
  doLogin: createAction(`${AUTH_TYPE}/doLogin`),
  doLogout: createAction(`${AUTH_TYPE}/doLogout`),
  getUserByJWT: createAction<string>(`${AUTH_TYPE}/getUserByJWT`),
  startCountDown: createAction<LoginByProjectData>(`${AUTH_TYPE}/startCountDown`),
};
